











































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import {
  sourceTypeListApi,
  sourceTypeAddApi,
  sourceTypeEditApi,
  sourceTypeDelApi,
} from "@/api/storeManagement";
import {
  createArrangeTime,
  editArrangeTime,
  deleteArrangeTime,
} from "@/api/classSchedule";
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
@Component({
  name: "setUpdialog",
  components: { stepTimeRangeSelector },
})
export default class extends Vue {
  @Prop() dialogType!: string;
  dialogVisible: boolean = false;
  showTable = true; // 显示table
  showCustomTable = true; // 显示自定义table
  showDefaultTable = true; // 显示默认table
  showAddText = true; // 显示添加
  textInfo: any = {
    daialogTitle: "",
    explain: "",
    title1: "",
    title2: "",
    tableTitle: "",
    addText: "",
  };
  input: string = "";
  tableData: any = [];
  time = {
    startTime: "12:00",
    endTime: "13:00",
  };
  tableCustomData: any = [];
  created() {}
  // 获取来源渠道列表
  getSourceTypeList() {
    sourceTypeListApi().then((res: any) => {
      if (res.error_code === 0) {
        this.tableCustomData = [];
        this.tableData = res.data.system_list;
        if (res.data.org_list.length > 0) {
          res.data.org_list.map((item: any) => {
            item.showTableInput = false;
            item.showTableEmit = false;
          });
        }
        this.tableCustomData = res.data.org_list;
      }
    });
  }
  showDialog() {
    this.showAddText = true; // 显示添加
    this.dialogVisible = true;
    if (this.dialogType === "channel") {
      this.textInfo = {
        daialogTitle: "设置来源渠道",
        explain: "默认渠道不可修改，门店可自行添加需要的来源渠道；",
        title1: "默认渠道",
        title2: "自定义渠道",
        tableTitle: "渠道名称",
        addText: "添加来源渠道",
      };
      this.getSourceTypeList();
    }
  }
  edit(val: any, ind: number) {
    this.tableCustomData[ind].showTableEmit = true;
    this.tableCustomData.map((item: any, index: number) => {
      if (ind !== index) {
        item.showTableInput = false;
        item.showTableEmit = false;
      }
      if (item.showAddInput) {
        this.tableCustomData.splice(index, 1);
      }
    });
    this.tableCustomData[ind].showTableInput = true;
    this.input = this.tableCustomData[ind].name;
    if (this.dialogType === "time") {
      this.time.startTime = this.tableCustomData[ind].start_time.slice(0, 5);
      this.time.endTime = this.tableCustomData[ind].end_time.slice(0, 5);
    }
    this.showAddText = true;
  }
  // 编辑
  preservation(val: any, ind: number) {
    if (this.dialogType === "channel") {
      sourceTypeEditApi({
        student_source_id: val.student_source_id,
        name: this.input,
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.getSourceTypeList();
          this.$message({
            type: "success",
            message: "修改成功",
          });
        }
      });
    }
    if (this.dialogType === "time") {
      editArrangeTime({
        time_id: val.time_id,
        start_time: this.time.startTime + ":00",
        end_time: this.time.endTime + ":00",
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "修改成功",
          });
        }
      });
    }
  }
  // 删除
  del(val: any) {
    if (this.dialogType === "channel") {
      sourceTypeDelApi({
        student_source_id: Number(val.student_source_id),
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.getSourceTypeList();
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.showAddText = true;
        }
      });
    }
    if (this.dialogType === "time") {
      deleteArrangeTime({
        time_id: Number(val.time_id),
      }).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.showAddText = true;
        }
      });
    }
  }
  cancel(ind: number) {
    this.tableCustomData[ind].showTableInput = false;
    this.tableCustomData[ind].showTableEmit = false;
  }
  // 添加阶段
  handleAdd() {
    this.tableCustomData.map((item: any, index: number) => {
      item.showTableInput = false;
      item.showTableEmit = false;
      if (item.showAddInput) {
        this.tableCustomData.splice(index, 1);
      }
    });
    this.input = "";
    this.time.startTime = "12:00";
    this.time.endTime = "13:00";
    this.tableCustomData.push({
      name: "",
      showTableInput: false,
      showAddInput: true,
    });
    this.tableCustomData[this.tableCustomData.length - 1].showTableInput = true;
    this.showAddText = false;
    this.showCustomTable = true; // 显示自定义table
    // 实现点击自定义添加自动滚到表格底部
    const bodyTable: any = this.$refs.editTable;
    this.$nextTick(() => {
      // bodyWrapper指向的是el-table的表格内容部分，存在 scrollTop，scrollHeight 属性
      bodyTable.bodyWrapper.scrollTop = bodyTable.bodyWrapper.scrollHeight;
    });
  }
  // 添加
  add(val: any, ind: number) {
    if (this.dialogType === "channel") {
      if (this.input !== "" && this.input.trim()) {
        sourceTypeAddApi({
          name: this.input,
        }).then((res: any) => {
          if (res.error_code === 0) {
            this.getSourceTypeList();
            this.input = "";
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.showAddText = true;
          }
        });
      }
    }
    if (this.dialogType === "time") {
      const data: any = {};
      if (this.time.startTime) {
        data.start_time = this.time.startTime + ":00";
      }
      if (this.time.endTime) {
        data.end_time = this.time.endTime + ":00";
      }
      createArrangeTime(data).then((res: any) => {
        if (res.error_code === 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.showAddText = true;
        }
      });
    }
  }
  quxiao() {
    this.tableCustomData.splice(this.tableCustomData.length - 1, 1);
    this.showAddText = true;
  }
}
